import React, { useContext, useEffect, useState } from 'react'
import { ContextNotification, severitys } from '../../../App';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Chip, Grid, Stack, TextField } from '@mui/material';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import hotelStructureApi from '../../../api/hotelStructureApi';


const AddStructureForm = ({ id, refreshGrid }) => {

  const { open, setOpen } = useContext(ContextNotification);
  const [submitLoading, setSubmitLoading] = useState(false);
  const schema = yup.object().shape({
    code: yup.string().required("کد ساختار را وارد نمایید"),
  });


  const { register, handleSubmit, formState: { errors }, control, watch, resetField } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    setSubmitLoading(true);


    const newData = {
      "hotelId": id,
      "code": data.code

    }
    hotelStructureApi.Add(newData).then(res => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        refreshGrid(true);
        resetForm();
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }
      else {
        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };
  useEffect(() => {

  }, []);


  const resetForm = () => {
    resetField("code");

  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: 10 }}>

        <Grid container spacing={2}>

          <Grid item md={12}>
            <TextField id="code" variant="outlined" {...register("code")} fullWidth label="کد" error={!!errors?.code}
              helperText={errors?.code?.message} />
          </Grid>

          <Grid item md={12}><Button variant='contained' type="submit" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} /> ثبت</Button></Grid>
        </Grid>

      </form>
    </div>
  )
}

export default AddStructureForm